import * as React from "react";
import type { SVGProps } from "react";
const SvgCornerDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.707 10.707a1 1 0 0 0-1.414-1.414zM4 15l-.707-.707a1 1 0 0 0 0 1.414zm4.293 5.707a1 1 0 0 0 1.414-1.414zM21 4a1 1 0 1 0-2 0zm-5 11v1zM8.293 9.293l-5 5 1.414 1.414 5-5zm-5 6.414 5 5 1.414-1.414-5-5zM19 4v7h2V4zm0 7a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 21 11zm-.879 2.121A3 3 0 0 1 16 14v2a5 5 0 0 0 3.535-1.464zM16 14H4v2h12z"
    />
  </svg>
);
export default SvgCornerDownLeft;
